import { createRouter, createWebHistory } from "vue-router";
import TestPage from "@/views/TestPage.vue";
import HomePage from "@/views/HomePage.vue";
import NotFound from "@/views/404.vue";
import beforeEachGuard from "@/router/routerGuard";
// admin
import AdminCategories from "@/views/Categories.vue";
import Products from "@/views/Products.vue";
import SettingsPage from "@/views/Settings.vue";
import MealExtra from "@/views/MealExtra.vue";
import Delivery from "@/views/Delivery.vue";
import Users from "@/views/Users.vue";
import Login from "@/views/Login.vue";
import PluView from "@/views/PluItems.vue";
import TextsView from "@/views/Texts.vue";
import FlyBurger from "@/views/FlyBurger.vue";
import Tables from "@/views/Tables.vue";

export const ROUTE_NAMES = {
  NO_FOUND_VIEW: "404_VIEW",
  TEST_VIEW: "TEST_VIEW",
  HOME_VIEW: "HOME_VIEW",
  CATEGORIES_VIEW: "CATEGORIES_VIEW",
  PRODUCT_VIEW: "PRODUCT_VIEW",
  SETTINGS_VIEW: "SETTINGS_VIEW",
  MEAL_EXTRA_VIEW: "MEAL_EXTRA_VIEW",
  DELIVERY_VIEW: "DELIVERY_VIEW",
  USERS_VIEW: "USERS_VIEW",
  LOGIN_VIEW: "LOGIN_VIEW",
  PLU_VIEW: "PLU_VIEW",
  TEXTS_VIEW: "TEXTS_VIEW",
  FLY_BURGER_VIEW: "FLY_BURGER_VIEW",
  TABLES_VIEW: "TABLES_VIEW",
};

const routes = [
  {
    path: "/",
    name: ROUTE_NAMES.HOME_VIEW,
    component: HomePage,
  },
  {
    path: "/plu",
    name: ROUTE_NAMES.PLU_VIEW,
    component: PluView,
  },
  {
    path: "/test",
    name: ROUTE_NAMES.TEST_VIEW,
    component: TestPage,
  },
  {
    path: "/categories",
    name: ROUTE_NAMES.CATEGORIES_VIEW,
    component: AdminCategories,
  },
  {
    path: "/meal-extra",
    name: ROUTE_NAMES.MEAL_EXTRA_VIEW,
    component: MealExtra,
  },
  {
    path: "/products",
    name: ROUTE_NAMES.PRODUCT_VIEW,
    component: Products,
  },
  {
    path: "/texts",
    name: ROUTE_NAMES.TEXTS_VIEW,
    component: TextsView,
  },
  {
    path: "/delivery",
    name: ROUTE_NAMES.DELIVERY_VIEW,
    component: Delivery,
  },
  {
    path: "/settings",
    name: ROUTE_NAMES.SETTINGS_VIEW,
    component: SettingsPage,
  },
  {
    path: "/users",
    name: ROUTE_NAMES.USERS_VIEW,
    component: Users,
  },
  {
    path: "/fly-burger",
    name: ROUTE_NAMES.FLY_BURGER_VIEW,
    component: FlyBurger,
  },
  {
    path: "/tables",
    name: ROUTE_NAMES.TABLES_VIEW,
    component: Tables,
  },
  {
    path: "/login",
    name: ROUTE_NAMES.LOGIN_VIEW,
    component: Login,
  },
  //404
  {
    path: "/:pathMatch(.*)*",
    name: ROUTE_NAMES.NO_FOUND_VIEW,
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(beforeEachGuard);

export default router;
